import { FeatureToggleType, FeatureToggleV2Type } from '../enum/FeatureToggleType'

/**
 * @deprecated 未來遊戲不再支援 v1 的 toggles，請改用 `parseFeatureToggleMapV2`。
 */
export const parseFeatureToggleMap = (input: string): Map<FeatureToggleType, boolean> => {
  const featureToggles = new Map<FeatureToggleType, boolean>()
  if (input.length !== 0) {
    const obj = JSON.parse(input)
    Object.keys(obj).forEach((x) => {
      if (x in FeatureToggleType) {
        const value = obj[x] === 'true'
        featureToggles.set(x as unknown as FeatureToggleType, value)
      }
    })
  }
  return featureToggles
}

export const parseFeatureToggleMapV2 = (input: string[]): Set<FeatureToggleV2Type> => {
  const featureToggles = new Set<FeatureToggleV2Type>()
  if (input.length === 0) {
    return featureToggles
  }
  input.forEach((toggle: string) => {
    if (toggle in FeatureToggleV2Type) {
      featureToggles.add(toggle as FeatureToggleV2Type)
    }
  })

  return featureToggles
}
